import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ContributionLayoutComponent } from "./contribution.layout";
import { ContributionComponent } from "./contribution.component";
import { ContributionRoutingModule } from "./contribution-routing.module";
import { ThemeModule } from "../@theme/theme.module";
import {
    NbAccordionModule,
    NbButtonModule,
    NbCardModule,
    NbListModule,
    NbProgressBarModule,
    NbRouteTabsetModule,
    NbTabsetModule,
    NbToastrModule,
} from "@nebular/theme";
import { TokenSaleDetailsComponent } from "./token-sale-details/token-sale-details.component";
import { RecentTransactionsComponent } from "./recent-transactions/recent-transactions.component";
import { PipesModule } from "../pipes/pipes.module";

@NgModule({
    declarations: [
        ContributionLayoutComponent,
        ContributionComponent,
        TokenSaleDetailsComponent,
        RecentTransactionsComponent,
    ],
    imports: [
        ContributionRoutingModule,
        CommonModule,
        ThemeModule,
        NbCardModule,
        NbButtonModule,
        NbAccordionModule,
        NbRouteTabsetModule,
        NbTabsetModule,
        NbListModule,
        NbToastrModule,
        NbProgressBarModule,
        PipesModule,
    ],
})
export class ContributionModule {}
